import Moment from "moment";
import ViewController from "core/views/view.controller";

export default class DurationViewCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);

        this.duration = null;
        this.durationFormat = null;
    }

    $onInit() {
        if (!this.durationFormat) {
            this.durationFormat = 'd [D] h [H] mm [M]';
        }
    }

    $onChanges(changes) {
        if (changes.durationMinutes || changes.durationStart || changes.durationEnd) {
            this.formatDuration();
        }
    }

    formatDuration() {
        var duration = this.durationMinutes;
        if (!duration && this.durationStart && this.durationEnd) {
            duration = Moment(this.endTime).diff(Moment(this.startTime), 'minutes');
        }

        if (!duration) {
            this.duration = null;
        }

        this.duration = Moment.duration(duration, 'minutes').format(this.durationFormat);
    }

}



// WEBPACK FOOTER //
// ./src/modules/core/components/duration/duration.controller.js